var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTree1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 32 32",
    id: "svg1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer6",
    transform: "translate(-32,-64)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2-2-6",
    transform: "translate(0,64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1-3-58-6-8-6-6-5-50-2-9-8-0-4-7",
    style: {
      fill: "#a5a664",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.999997,
      strokeLinejoin: "round"
    },
    d: "m 41.27456,22.730069 c 0.18868,0.188679 3.63271,-0.443079 4.52831,-1.886792 0.3653,-0.588883 0.1895,-1.552919 -0.25354,-2.121173 l -0.68986,0.68986 v 1.431312 c 0,0.10421 -0.0845,0.188678 -0.1887,0.188678 -0.10422,0 -0.18868,-0.08449 -0.18868,-0.188678 v -1.053954 l -0.7547,0.754716 v 0.67512 c 0,0.10421 -0.0845,0.18868 -0.1887,0.18868 -0.10422,0 -0.18868,-0.08446 -0.18868,-0.18868 v -0.297757 l -0.80999,0.809993 c -0.0737,0.07366 -0.19313,0.07366 -0.26681,0 -0.0737,-0.07368 -0.0737,-0.19312 0,-0.266802 l 0.81,-0.809995 h -0.30181 -0.002 c -0.24805,-0.0037 -0.24805,-0.373854 0,-0.377363 h 0.002 0.67917 l 0.75474,-0.754714 h -1.05396 c -0.10422,0 -0.18868,-0.08449 -0.18868,-0.18868 0,-0.10421 0.0845,-0.188679 0.18868,-0.188679 h 1.43132 l 0.69087,-0.690872 c -0.57017,-0.45238 -1.52127,-0.622035 -2.12218,-0.252526 -1.44088,0.88601 -2.07548,4.339626 -1.8868,4.528306 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path9-0-6-3-8-3-4-0",
    style: {
      color: "#000000",
      fill: "#a5a664",
      fillOpacity: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "m 46,17.5 c -0.127554,0 -0.282657,0.04042 -0.353516,0.146484 -0.130923,0.195967 -0.08875,0.488703 0,0.707032 C 45.934973,19.063222 46.961511,19.290294 47.25,20 c 1.004182,2.47037 -1.020489,5.536321 0,8 0.135299,0.326641 0.396447,0.75 0.75,0.75 0.353553,0 0.614701,-0.423359 0.75,-0.75 1.020489,-2.463679 -1.004162,-5.529622 0,-8 0.288479,-0.709699 1.31499,-0.936789 1.603469,-1.646488 0.08875,-0.21833 0.130919,-0.511063 0,-0.707032 C 50.282621,17.540429 50.127539,17.500002 50,17.5 c -0.127554,-2e-6 -0.246997,0.07631 -0.353516,0.146484 C 49.006723,18.067927 48.766099,19.25 48,19.25 47.233901,19.25 46.993277,18.067927 46.353516,17.646484 46.246997,17.576314 46.127554,17.5 46,17.5 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000000",
      fill: "#7d451b",
      fillOpacity: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "m 44,26 a 2,2 0 0 0 -2,2 2,2 0 0 0 2,2 h 8 a 2,2 0 0 0 2,-2 2,2 0 0 0 -2,-2 z",
    id: "path1-04-9-9-2-2-0-9-7"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "none",
      stroke: "none",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "miter"
    },
    id: "rect24-8-9-3",
    width: 32,
    height: 32,
    x: 32,
    y: 0,
    rx: 0,
    ry: 2.7755576e-17
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTree1);
export default __webpack_public_path__ + "static/media/icon_tree1.6fddc91396ce0685ad69bf583181711d.svg";
export { ForwardRef as ReactComponent };